import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import ReinforcementV from '../ReinforcementV';

const ReinforcementBody = ({
  itemData = {}, // Default to an empty object to avoid undefined errors
  showBotDetails,
  showTopDetails,
  toggleBotForm,
  toggleTopForm,
  fetchElment,
  handleBack,
}) => {
  // Added state to force re-render when itemData updates
  const [renderKey, setRenderKey] = useState(0);

  // Trigger re-render whenever itemData updates
  useEffect(() => {
    setRenderKey((prevKey) => prevKey + 1);
  }, [itemData]);

  return (
    <>
      <div className="body-container  rounded border p-1">
       
        {/* BOT Reinforcement */}
        <div className="Form-Panel m-1 px-2 py-2">
          <div className="title-border-bottom">
            <button className="toggle-btn my-3 mx-5" onClick={toggleBotForm}>
              <FontAwesomeIcon className="mx-2" icon={faArrowDown} />
              BOT. REINFORCEMENT (MM)
            </button>
          </div>
          
          {showBotDetails && (
  <>
    <div
      key={Math.random()} // Random key to force re-render
      className="d-flex mx-5 mt-3 row"
    >
      <div className="mb-2 d-flex flex-column mx-3 col-md-3">
        <label htmlFor="thickness">L Long</label>
        <p id="thickness" className="form-control mt-2 w-100 d-inline">
          {itemData?.partLot_BOTLong_c || itemData?.PartLot_BOTLong_c}
        </p>
      </div>
      <div className="mb-2 d-flex flex-column mx-3 col-md-3">
        <label htmlFor="thickness">E CROSS</label>
        <p id="width" className="form-control mt-2 w-100 d-inline">
          {itemData?.partLot_BOTECROS_c || itemData?.PartLot_BOTECROS_c}
        </p>
      </div>
      <div className="mb-2 d-flex flex-column mx-3 col-md-3">
        <label htmlFor="thickness">D CROSS</label>
        <p id="length" className="form-control mt-2 w-100 d-inline">
          {itemData?.partLot_BOTDCROS_c || itemData?.PartLot_BOTDCROS_c}
        </p>
      </div>
    </div>
    <ReinforcementV
  L={parseInt(itemData?.partLot_BOTLong_c?.split('Ø')[0] || itemData?.PartLot_BOTLong_c?.split('Ø')[0] || 0)}
  E={parseInt(itemData?.partLot_BOTECROS_c?.split('Ø')[0] || itemData?.PartLot_BOTECROS_c?.split('Ø')[0] || 0)}
  D={parseInt(itemData?.partLot_BOTDCROS_c?.split('Ø')[0] || itemData?.PartLot_BOTDCROS_c?.split('Ø')[0] || 0)}
  slabLength={parseInt(itemData?.partLot_Length_c || itemData?.PartLot_Length_c || 0)}
  slabWidth={parseInt(itemData?.partLot_Width_c || itemData?.PartLot_Width_c || 0)}
  slabThickness={parseInt(itemData?.partLot_Depth_c || itemData?.PartLot_Depth_c || 0)}
/>
  </>
)}



        </div>

        {/* TOP Reinforcement */}
        <div className="Form-Panel m-1 px-2 py-2">
          <div className="title-border-bottom">
            <button className="toggle-btn my-3 mx-5" onClick={toggleTopForm}>
              <FontAwesomeIcon className="mx-2" icon={faArrowDown} />
              TOP. REINFORCEMENT (MM)
            </button>
          </div>
          {showTopDetails && (
            <>
              <div className="d-flex mx-5 mt-3 row">
                <div className="mb-2 d-flex flex-column mx-3 col-md-3">
                  <label htmlFor="thickness">L LONG</label>
                  <p
                    id="thickness"
                    className="form-control w-100 d-inline mt-2"
                  >
                    {itemData?.partLot_TOPLong_c || itemData?.PartLot_TOPLong_c}
                  </p>
                </div>
                <div className="mb-2 d-flex flex-column mx-3 col-md-3">
                  <label htmlFor="thickness">E CROSS</label>
                  <p id="width" className="form-control w-100 d-inline mt-2">
                    {itemData?.partLot_TOPECROS_c || itemData?.PartLot_TOPECROS_c}
                  </p>
                </div>
                <div className="mb-2 d-flex flex-column mx-3 col-md-3">
                  <label htmlFor="thickness">D CROSS</label>
                  <p id="length" className="form-control w-100 d-inline mt-2">
                    {itemData?.partLot_TOPDCROS_c || itemData?.PartLot_TOPDCROS_c}
                  </p>
                </div>
              </div>

              <ReinforcementV
  L={parseInt(itemData?.partLot_TOPLong_c?.split('Ø')[0] || itemData?.PartLot_TOPLong_c?.split('Ø')[0] || 0)}
  E={parseInt(itemData?.partLot_TOPECROS_c?.split('Ø')[0] || itemData?.PartLot_TOPECROS_c?.split('Ø')[0] || 0)}
  D={parseInt(itemData?.partLot_TOPDCROS_c?.split('Ø')[0] || itemData?.PartLot_TOPDCROS_c?.split('Ø')[0] || 0)}
  slabLength={parseInt(itemData?.partLot_Length_c || itemData?.PartLot_Length_c || 0)}
  slabWidth={parseInt(itemData?.partLot_Width_c || itemData?.PartLot_Width_c || 0)}
  slabThickness={parseInt(itemData?.partLot_Depth_c || itemData?.PartLot_Depth_c || 0)}
/>

            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ReinforcementBody;